// extracted by mini-css-extract-plugin
module.exports = {"formContainerClassName":"BusinessInfoTab_formContainerClassName__3TZye","businessBtnLink":"BusinessInfoTab_businessBtnLink__2LpVu"};